import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 8.5H3.70005L8.20005 13H6.80005L1.80005 8L6.80005 3H8.20005L3.70005 7.5H14V8.5Z",
		fill: "currentColor"
	})
});
export default SvgArrowLeft;
